<template>
  <div class="contact-header">
    <div :class="{'contact-header-inner': mounted}"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      mounted: false
    }
  },
  mounted () {
    this.mounted = true
  }
}
</script>

<style lang="stylus">
.contact-header
  background #f2f5f6 url('../../assets/images/contact.png') no-repeat
  background-size cover
  height 350px

.contact-header-inner
  background url('../../assets/images/contact_big.png') no-repeat
  background-size cover
  height 350px
</style>
